import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, ChevronDown, ChevronUp, Truck, CheckCircle, Clock, ArrowRight } from 'lucide-react';
import Header from './components/Header22';
import Footer from './components/Footer22';

const Orders22 = () => {
    const navigate = useNavigate();
    const [expandedOrder, setExpandedOrder] = useState(null);
    const [showEmpty, setShowEmpty] = useState(false);

    const orders = [
        {
            id: 'MAATI-2026001',
            date: '15 Mar 2026',
            status: 'delivered',
            total: 8999,
            items: [
                {
                    name: 'Chanderi Silk Saree',
                    quantity: 1,
                    size: 'Free Size',
                    price: 8999,
                    image: 'https://images.pexels.com/photos/10679171/pexels-photo-10679171.jpeg?auto=compress&cs=tinysrgb&w=800',
                },
            ],
            shippingAddress: '45 Heritage Lane, Bandra West, Mumbai 400050',
            trackingNumber: 'MAATI-TRK-78291',
            deliveredDate: '20 Mar 2026',
        },
        {
            id: 'MAATI-2026002',
            date: '10 Mar 2026',
            status: 'in_transit',
            total: 20499,
            items: [
                {
                    name: 'Banarasi Zari Lehenga',
                    quantity: 1,
                    size: 'M',
                    price: 15999,
                    image: 'https://images.pexels.com/photos/9419032/pexels-photo-9419032.jpeg?auto=compress&cs=tinysrgb&w=800',
                },
                {
                    name: 'Block Print Kurta Set',
                    quantity: 1,
                    size: 'S',
                    price: 4500,
                    image: 'https://images.pexels.com/photos/8838890/pexels-photo-8838890.jpeg?auto=compress&cs=tinysrgb&w=800',
                },
            ],
            shippingAddress: '12 Craft Colony, Jaipur, Rajasthan 302001',
            trackingNumber: 'MAATI-TRK-78405',
            expectedDelivery: '22 Mar 2026',
        },
        {
            id: 'MAATI-2026003',
            date: '5 Mar 2026',
            status: 'processing',
            total: 6800,
            items: [
                {
                    name: 'Chikankari Anarkali',
                    quantity: 1,
                    size: 'M',
                    price: 6800,
                    image: 'https://images.pexels.com/photos/7123307/pexels-photo-7123307.jpeg?auto=compress&cs=tinysrgb&w=800',
                },
            ],
            shippingAddress: '8 Artisan Road, Lucknow, UP 226001',
            trackingNumber: null,
            note: 'Being handcrafted by artisans. Expected dispatch in 3-5 days.',
        },
    ];

    const getStatusConfig = (status) => {
        const config = {
            delivered: { label: 'Delivered', color: '#2E7D32', bg: '#E8F5E9', icon: CheckCircle },
            in_transit: { label: 'In Transit', color: '#C4572A', bg: '#FFF0EB', icon: Truck },
            processing: { label: 'Handcrafting', color: '#8B7355', bg: '#F3ECE4', icon: Clock },
        };
        return config[status] || config.processing;
    };

    if (showEmpty || orders.length === 0) {
        return (
            <>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Infant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Source+Sans+3:wght@300;400;500;600;700&display=swap');
                `}</style>
                <div style={{ minHeight: '100vh', backgroundColor: '#FAF6F1', fontFamily: "'Source Sans 3', -apple-system, sans-serif" }}>
                    <Header />
                    <div style={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        minHeight: '60vh', padding: '120px 24px 80px', textAlign: 'center',
                    }}>
                        <div style={{
                            width: '80px', height: '80px', borderRadius: '50%',
                            backgroundColor: '#F3ECE4', display: 'flex',
                            alignItems: 'center', justifyContent: 'center', marginBottom: '24px',
                        }}>
                            <Package size={32} color="#C4572A" />
                        </div>
                        <h2 style={{
                            fontFamily: "'Cormorant Infant', Georgia, serif",
                            fontSize: '32px', fontWeight: 500, color: '#5C3D2E', marginBottom: '12px',
                        }}>
                            No Orders Yet
                        </h2>
                        <p style={{ fontSize: '16px', color: '#8B7355', marginBottom: '32px', maxWidth: '400px' }}>
                            Your handcrafted treasures await. Explore our collection and bring a piece of Indian heritage home.
                        </p>
                        <button
                            onClick={() => navigate('/template22/shop')}
                            style={{
                                padding: '14px 36px', backgroundColor: '#C4572A', color: '#FFFFFF',
                                border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 600,
                                letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer',
                                fontFamily: "'Source Sans 3', sans-serif", transition: 'all 0.3s ease',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#D4683B'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C4572A'; }}
                        >
                            Start Shopping
                        </button>
                    </div>
                    <Footer />
                </div>
            </>
        );
    }

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Infant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Source+Sans+3:wght@300;400;500;600;700&display=swap');
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#FAF6F1', fontFamily: "'Source Sans 3', -apple-system, sans-serif" }}>
                <Header />

                <div style={{ maxWidth: '900px', margin: '0 auto', padding: '120px 24px 80px' }}>
                    <h1 style={{
                        fontFamily: "'Cormorant Infant', Georgia, serif",
                        fontSize: '40px', fontWeight: 500, color: '#5C3D2E',
                        marginBottom: '8px',
                    }}>
                        My Orders
                    </h1>
                    <p style={{ fontSize: '15px', color: '#8B7355', marginBottom: '40px' }}>
                        Track your handcrafted treasures
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        {orders.map(order => {
                            const statusConfig = getStatusConfig(order.status);
                            const StatusIcon = statusConfig.icon;
                            const isExpanded = expandedOrder === order.id;

                            return (
                                <div
                                    key={order.id}
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        borderRadius: '12px',
                                        border: '1px solid #E8DDD0',
                                        overflow: 'hidden',
                                        transition: 'box-shadow 0.3s ease',
                                    }}
                                >
                                    {/* Order Header */}
                                    <div
                                        onClick={() => setExpandedOrder(isExpanded ? null : order.id)}
                                        style={{
                                            padding: '24px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flex: 1, flexWrap: 'wrap' }}>
                                            {/* First Item Image */}
                                            <div style={{
                                                width: '64px', height: '80px', borderRadius: '6px',
                                                overflow: 'hidden', flexShrink: 0,
                                            }}>
                                                <img src={order.items[0].image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                            </div>

                                            <div style={{ flex: 1, minWidth: '200px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', marginBottom: '6px' }}>
                                                    <span style={{ fontSize: '16px', fontWeight: 600, color: '#5C3D2E' }}>
                                                        {order.id}
                                                    </span>
                                                    <span style={{
                                                        display: 'inline-flex', alignItems: 'center', gap: '4px',
                                                        padding: '4px 12px', borderRadius: '20px',
                                                        backgroundColor: statusConfig.bg, color: statusConfig.color,
                                                        fontSize: '12px', fontWeight: 600,
                                                    }}>
                                                        <StatusIcon size={12} /> {statusConfig.label}
                                                    </span>
                                                </div>
                                                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                                                    <span style={{ fontSize: '13px', color: '#8B7355' }}>
                                                        Placed: {order.date}
                                                    </span>
                                                    <span style={{ fontSize: '13px', color: '#8B7355' }}>
                                                        {order.items.length} {order.items.length === 1 ? 'item' : 'items'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                            <span style={{
                                                fontSize: '20px', fontWeight: 700, color: '#C4572A',
                                                fontFamily: "'Cormorant Infant', serif",
                                            }}>
                                                {'\u20B9'}{order.total.toLocaleString('en-IN')}
                                            </span>
                                            {isExpanded ? <ChevronUp size={20} color="#8B7355" /> : <ChevronDown size={20} color="#8B7355" />}
                                        </div>
                                    </div>

                                    {/* Expanded Details */}
                                    {isExpanded && (
                                        <div style={{
                                            borderTop: '1px solid #E8DDD0',
                                            padding: '24px',
                                            backgroundColor: '#FDFBF8',
                                        }}>
                                            {/* Items */}
                                            <div style={{ marginBottom: '24px' }}>
                                                {order.items.map((item, i) => (
                                                    <div key={i} style={{
                                                        display: 'flex', gap: '16px',
                                                        padding: '12px 0',
                                                        borderBottom: i < order.items.length - 1 ? '1px solid #E8DDD0' : 'none',
                                                    }}>
                                                        <div style={{
                                                            width: '72px', height: '90px', borderRadius: '6px',
                                                            overflow: 'hidden', flexShrink: 0,
                                                        }}>
                                                            <img src={item.image} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                        </div>
                                                        <div style={{ flex: 1 }}>
                                                            <p style={{
                                                                fontFamily: "'Cormorant Infant', serif",
                                                                fontSize: '17px', fontWeight: 600, color: '#5C3D2E', margin: '0 0 4px 0',
                                                            }}>
                                                                {item.name}
                                                            </p>
                                                            <p style={{ fontSize: '13px', color: '#8B7355', margin: '0 0 4px 0' }}>
                                                                Size: {item.size} | Qty: {item.quantity}
                                                            </p>
                                                            <p style={{ fontSize: '15px', fontWeight: 600, color: '#C4572A', margin: 0 }}>
                                                                {'\u20B9'}{item.price.toLocaleString('en-IN')}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Shipping & Tracking */}
                                            <div style={{
                                                display: 'grid', gridTemplateColumns: '1fr 1fr',
                                                gap: '20px', marginBottom: '20px',
                                            }}>
                                                <div style={{
                                                    backgroundColor: '#F3ECE4', borderRadius: '8px', padding: '16px',
                                                }}>
                                                    <p style={{ fontSize: '12px', fontWeight: 600, color: '#8B7355', margin: '0 0 6px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                        Shipping To
                                                    </p>
                                                    <p style={{ fontSize: '14px', color: '#5C3D2E', margin: 0, lineHeight: 1.5 }}>
                                                        {order.shippingAddress}
                                                    </p>
                                                </div>
                                                <div style={{
                                                    backgroundColor: '#F3ECE4', borderRadius: '8px', padding: '16px',
                                                }}>
                                                    <p style={{ fontSize: '12px', fontWeight: 600, color: '#8B7355', margin: '0 0 6px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                        {order.status === 'delivered' ? 'Delivered On' : order.status === 'in_transit' ? 'Expected By' : 'Status'}
                                                    </p>
                                                    <p style={{ fontSize: '14px', color: '#5C3D2E', margin: '0 0 4px 0' }}>
                                                        {order.deliveredDate || order.expectedDelivery || order.note || 'Processing'}
                                                    </p>
                                                    {order.trackingNumber && (
                                                        <p style={{ fontSize: '12px', color: '#C4572A', margin: 0 }}>
                                                            Tracking: {order.trackingNumber}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Actions */}
                                            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                                                {order.status === 'delivered' && (
                                                    <button
                                                        style={{
                                                            padding: '10px 20px', backgroundColor: '#C4572A',
                                                            color: '#FFFFFF', border: 'none', borderRadius: '6px',
                                                            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
                                                            fontFamily: "'Source Sans 3', sans-serif",
                                                            transition: 'all 0.3s ease',
                                                        }}
                                                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#D4683B'; }}
                                                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C4572A'; }}
                                                    >
                                                        Write a Review
                                                    </button>
                                                )}
                                                <button
                                                    style={{
                                                        padding: '10px 20px', backgroundColor: 'transparent',
                                                        color: '#5C3D2E', border: '1px solid #E8DDD0', borderRadius: '6px',
                                                        fontSize: '13px', fontWeight: 600, cursor: 'pointer',
                                                        fontFamily: "'Source Sans 3', sans-serif",
                                                    }}
                                                >
                                                    Need Help?
                                                </button>
                                                {order.status === 'in_transit' && (
                                                    <button
                                                        style={{
                                                            padding: '10px 20px', backgroundColor: 'transparent',
                                                            color: '#C4572A', border: '1px solid #C4572A', borderRadius: '6px',
                                                            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
                                                            fontFamily: "'Source Sans 3', sans-serif",
                                                            display: 'flex', alignItems: 'center', gap: '6px',
                                                        }}
                                                    >
                                                        Track Order <ArrowRight size={14} />
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Orders22;
